import { ONBOARDING_PATHS } from '../../route-constants';

export const CREATE_ACCOUNT_AND_CONTACT_SUB_PATHS = {
  overview: 'overview',
  createAccount: 'create-account',
  addContact: 'add-contact',
} as const;

export type CreateAccountAndContactSubPath =
  (typeof CREATE_ACCOUNT_AND_CONTACT_SUB_PATHS)[keyof typeof CREATE_ACCOUNT_AND_CONTACT_SUB_PATHS];

export const getCreateAccountAndContactSubRoute = (
  subPath: CreateAccountAndContactSubPath
) => `${ONBOARDING_PATHS.createAccountAndContact}/${subPath}`;

export { ONBOARDING_PATHS };
